<template>
  <v-card class="elevation-2">
    <v-card-text>
      <v-timeline align-top dense class="scroll-box">
        <v-timeline-item v-for="(movement, index) in movements" :key="index" :color="movement.estatus.color" small>
          <div>
            <div class="font-weight-normal">
              <v-chip :color="movement.estatus.color" label outlined>{{ movement.estatus.estatus }}</v-chip>
              @ <label class="font-weight-bold subtitle-2 text--primary">
                  {{ new Date(movement.created_at).toISOString().substr(0, 10) }}
                  {{ new Date(movement.created_at).toLocaleTimeString('it-IT') }}
                </label>
            </div>
            <div v-if="movement.detalle" class="pl-1">
              <!-- {{ movement.detalle.descripcion.empleado_id }} -->

              <div v-if="movement.detalle.descripcion.empleado_id" class="pl-1 pt-1">
                  <p class="font-italic">
                      <span class="font-weight-bold font-weight-black">Realizo: </span>
                      {{ movement.detalle.descripcion?.empleado?.NombreCompleto || '' }}
                  </p>
              </div>
              <div v-if="movement.detalle.descripcion.asignado_id" class="pl-1 pt-1">
                  <p class="font-italic">
                      <span class="font-weight-bold font-weight-black">Asignado: </span>
                      {{ movement.detalle.descripcion?.asignado?.NombreCompleto || '' }}
                  </p>
              </div>
              <div v-if="movement.detalle.descripcion.comentarios" class="pl-1 pt-1">
                  <p class="font-italic">
                      <span class="font-weight-bold font-weight-black">Comentarios: </span>
                      {{ movement.detalle.descripcion?.comentarios || '' }}
                  </p>
              </div>
              <div v-if="movement.detalle.descripcion.observaciones" class="pl-1 pt-1">
                  <p class="font-italic">
                      <span class="font-weight-bold font-weight-black">Observaciones: </span>
                      {{ movement.detalle.descripcion?.observaciones || '' }}
                  </p>
              </div>
                <!-- <p class="font-italic ma-0">
                  <span v-if="field.nameid == 'empleado_id'">
                    {{ movement.detalle.descripcion[field.name.toLowerCase()]?.NombreCompleto || movement.detalle.descripcion[field.nameid.toLowerCase()]?.descripcion || 'N/A' }}
                  </span>
                  <span v-else-if="movement.detalle.descripcion[field.name.toLowerCase()]">
                    {{ movement.detalle.descripcion[field.name.toLowerCase()]?.nombre || movement.detalle.descripcion[field.name.toLowerCase()]?.NombreCompleto || 'N/A' }}
                  </span>
                  <span v-else>
                    {{ movement.detalle.descripcion?.comentarios || movement.detalle.descripcion?.descripcion || movement.detalle.descripcion?.concepto?.conceptos || 'N/A' }}
                  </span>
                </p> -->
              <p v-if="movement.detalle.descripcion.logs">
                    <span class="font-weight-bold font-weight-black subtitle-1"> Observaciones:</span><br/>
                    <span v-for="(log,index) in movement.detalle.descripcion.logs" :key="index"
                      class="ma-2" color="cyan" outlined>
                      <v-icon left>mdi-check-circle</v-icon>
                      {{ log.estatus }} -- {{ log.fecha }}
                    </span>
              </p>
            </div>
          </div>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import { HeaderGral } from '@/store/modules/config'

export default {
  props: ['itemAction', 'onSuccess'],
  data: () => ({
    movements: []
  }),
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.itemAction.url)
    }
  },
  methods: {
    getDinamicData (url) {
      const header = HeaderGral()
      axios.get(url, header).then((response) => {
        this.movements = response.data || []
      }).catch((error) => {
        console.error('Error:', error)
      })
    }
  }
}
</script>

<style scoped>
.scroll-box {
  min-height: 300px;
  max-height: 1000px;
  width: 100%;
  overflow-x: auto;
}
</style>
